import { render } from "./ProblemsRow.vue?vue&type=template&id=129b45de&ts=true"
import script from "./ProblemsRow.ts?vue&type=script&lang=ts&external"
export * from "./ProblemsRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__